module.exports = "/_next/static/images/blue-sticker_en-8ba79a55c690491bac80eb89e4d01a86.png";